"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorHandler = void 0;
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ErrorHandler = exports.ErrorHandler = function ErrorHandler(props) {
  var _props$state = props.state,
    state = _props$state === void 0 ? {} : _props$state,
    _props$mapStateToErro = props.mapStateToError,
    mapStateToError = _props$mapStateToErro === void 0 ? function () {} : _props$mapStateToErro,
    children = props.children;
  (0, _react.useEffect)(function () {
    var prevOnError = window.onerror;
    window.onerror = function (event, fileName, line, col, error) {
      if (prevOnError) {
        prevOnError(event, fileName, line, col, error);
      }
      _nuiLogger.default.error({
        err: error,
        description: "".concat(JSON.stringify({
          event: event,
          fileName: fileName,
          line: line,
          col: col
        })),
        subcategory: 'browser-error',
        nui_data: mapStateToError(state)
      });
    };
  }, []);
  return _react.default.Children.only(children);
};
ErrorHandler.propTypes = {
  mapStateToError: _propTypes.default.func
};
var _default = exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    state: state
  };
})(ErrorHandler);